import { ChangeEvent, useState } from 'react';
import {
  Divider,
  Box,
  FormControl,
  InputLabel,
  Card,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  TableContainer,
  Select,
  MenuItem,
  CardHeader,
} from '@mui/material';
import SuspenseLoader from 'src/components/SuspenseLoader';
import { IFairSingleMemberApplication } from 'src/Types/module/fairSingleMemberApplication/fairSingleMemberApplication';
import SingleFairApplicationTableRow from './SingleFairApplicationTableRaw';
import { applyPagination } from 'src/Utils/CommonAllShowUtils';
import { TableLoader, TableNotFound } from 'src/Utils/TableLoader';

const SingleFairApplicationTable = ({
  allAdmin,
  loading,
  setStatus,
  status,
  setReload,
}) => {
  const [page, setPage] = useState<number>(0);
  const [limit, setLimit] = useState<number>(25);
  const statusOptions = [
    {
      id: 'all',
      name: 'All',
    },
    {
      id: 'pending',
      name: 'Pending',
    },
    {
      id: 'approved',
      name: 'Approved',
    },
    {
      id: 'rejected',
      name: 'Rejected',
    },
  ];

  const handlePageChange = (event: any, newPage: number): void => {
    setPage(newPage);
  };

  const handleLimitChange = (event: ChangeEvent<HTMLInputElement>): void => {
    setLimit(parseInt(event.target.value));
  };

  const paginatedInvoice = applyPagination(allAdmin, page, limit);

  return (
    <Card>
      <CardHeader
        action={
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              width: '320px',
            }}
          >
            <FormControl fullWidth variant='outlined'>
              <InputLabel>Status</InputLabel>
              <Select
                value={status}
                onChange={(e) => setStatus(e.target.value)}
                label='Status'
                autoWidth
              >
                {statusOptions.map((statusOption) => (
                  <MenuItem key={statusOption.id} value={statusOption.id}>
                    {statusOption.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        }
        title='Fair application List'
      />

      <Divider />
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Application ID</TableCell>
              <TableCell>Member contact name</TableCell>
              <TableCell>Member company name</TableCell>
              <TableCell>Member ID</TableCell>
              <TableCell>Application date</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>

          {loading ? (
            <TableLoader />
          ) : paginatedInvoice.length ? (
            <TableBody>
              {paginatedInvoice.map(
                (allAdmin: IFairSingleMemberApplication) => {
                  return (
                    <SingleFairApplicationTableRow
                      key={allAdmin.fair_stall_application_id}
                      allAdmin={allAdmin}
                      setReload={setReload}
                    />
                  );
                }
              )}
            </TableBody>
          ) : <TableNotFound />}
        </Table>
      </TableContainer>
      <Box p={2}>
        <TablePagination
          component='div'
          count={allAdmin.length}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleLimitChange}
          page={page}
          rowsPerPage={limit}
          rowsPerPageOptions={[25, 50, 75, 100]}
        />
      </Box>
    </Card>
  );
};

export default SingleFairApplicationTable;
